class ProductStyledWith extends HTMLElement {
  constructor() {
    super();

    if (this.getAttribute('aria-controls')) {
      this.controls = this.getAttribute('aria-controls')
        .split(' ')
        .map((id) => document.getElementById(id));

      this.variantChange = function (e) {
        this.replaceSelf(e.detail.swatch);
      };

      this.variantChangeHandler = this.variantChange.bind(this);

      this.controls.forEach((control) => {
        if (!control) {
          return;
        }
        control.addEventListener('swatch:change', this.variantChangeHandler);
      });
    }

    if (this.querySelector('[styled-with-products]').children.length === 0) {
      onTagalysReady(this.fetchTagalysRecommendations.bind(this));
    }
  }

  get sectionId() {
    return this.getAttribute('section-id');
  }

  set sectionId(sectionId) {
    this.setAttribute('section-id', sectionId);
  }

  disconnectedCallback() {
    this.controls.forEach((control) => control.removeEventListener('swatch:change', this.variantChangeHandler));
  }

  async replaceSelf(swatch) {
    try {
      const response = await fetch(`${swatch.href}?section_id=${this.sectionId}`);
      const result = await response.text();
      this.replaceSection(result);
    } catch (e) {
      console.error(e.message);
    }
  }

  retrieveAvailableUrls(products, sectionId) {
    return products
      .filter((product) => product.available)
      .map(
        (product) =>
          `${window.Shopify.routes.root}products/${product.handle + (sectionId ? `?section_id=${sectionId}` : '')}`,
      );
  }

  hydrateProductsWithSection(products, sectionId) {
    const availableUrls = this.retrieveAvailableUrls(products, sectionId);
    const promiseList = [];
    availableUrls.forEach((url) => {
      promiseList.push(
        new Promise((resolve, reject) => {
          fetch(url)
            .then((res) => {
              if (!res.ok) {
                throw new Error();
              }

              return res.text();
            })
            .then((res) => {
              const section = new DOMParser().parseFromString(res, 'text/html').querySelector('.shopify-section');
              return resolve(section.innerHTML);
            })
            .catch((err) => reject(err));
        }),
      );
    });

    return new Promise((resolve, reject) => {
      Promise.allSettled(promiseList)
        .then((result) => {
          const recommendations = result
            .filter((promise) => promise.status === 'fulfilled')
            .map((promise) => promise.value)
            .join(' ');

          resolve(recommendations);
        })
        .catch((err) => reject(err));
    });
  }

  fetchTagalysRecommendations(productId = this.getAttribute('product-id')) {
    Tagalys.APIConnector.Recommendations.call({
      params: { productId, recommendationId: this.getAttribute('widget-id'), limit: 4 },
      onSuccess: function (response, helpers) {
        if (!Array.isArray(response.products) || (Array.isArray(response.products) && response.products.length === 0)) {
          return;
        }

        this.hydrateProductsWithSection(response.products, 'product-styled-with-product-card')
          .then((html) => {
            this.renderInnerHTML(html, `product-styled-with[section-id="${this.sectionId}"] [styled-with-products]`);
            this.setAttribute('data-source', 'tagalys');
            this.removeAttribute('hidden');
          })
          .catch((err) => {
            console.error(`Failed to retrieve product-card for Tagalys recommendations.`, err);
          });
      }.bind(this),
      onFailure: function (response, helpers) {
        console.error(`Failed to retrieve recommendations from Tagalys for product-styled-with.`, { response });
      },
    });
  }

  replaceSection(html, selector = `#shopify-section-${this.sectionId}`) {
    document.querySelector(selector).outerHTML = html;
  }

  renderInnerHTML(innerHTML, selector = `#shopify-section-${this.sectionId}`) {
    document.querySelector(selector).innerHTML = innerHTML;
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}
customElements.define('product-styled-with', ProductStyledWith);
